import styled from 'styled-components';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import StoreLogo from '@karma/components/StoreLogo';
import Stack from '@karma/components/Stack';
import { Typography } from '@karma/components';

export const CardContainer = styled.a`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  margin: 0;
  gap: 8px;
`;

export const ImageContainer = styled.div`
  display: flex;
  width: 100%;
  overflow: hidden;
  border-radius: 10px;
  position: relative;

  & > .lazy-load-image-loaded {
    overflow: hidden;
    position: absolute;
    border-radius: 10px;
    width: 100%;
    height: 100%;
    z-index: 5;
  }
`;

export const StyledStoreLogo = styled(StoreLogo)`
  position: absolute;
  bottom: 16px;
  left: 16px;
  z-index: 6;
`;

export const BrandImage = styled(LazyLoadImage)`
  overflow: hidden;
  object-fit: cover;
  object-position: center;
  border-radius: 10px;
  width: 100%;
  height: 100%;
  z-index: 5;
`;

export const MakerContainer = styled(Stack)`
  position: absolute;
  left: 0;
  top: 20px;
  z-index: 6;
`;

export const StyledTypography = styled(Typography)`
  overflow-wrap: anywhere;
`;
